// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: '5786478b-f99b-4f4e-99ce-c731ac9cd811',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '3752231d-455a-4b14-952e-2b00eeb3fcd9',
      type: 'Sprite',
      name: 'gradient',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 15.6,
        y: 2
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'WinStreak_Blue_Gradient',
      parent: '5786478b-f99b-4f4e-99ce-c731ac9cd811'
    },
    {
      id: 'b922a807-03c8-4a74-b732-28bdab07c809',
      type: 'Container',
      name: 'fxLayer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5786478b-f99b-4f4e-99ce-c731ac9cd811'
    },
    {
      id: '03d602f0-9a69-449a-b822-63c64b360008',
      type: 'Container',
      name: 'rankedFrames',
      className: '',
      x: 0,
      y: 111,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5786478b-f99b-4f4e-99ce-c731ac9cd811'
    },
    {
      id: '051c83b9-48ca-48bc-a7e8-b938b397941b',
      type: 'Container',
      name: 'chests',
      className: '',
      x: 0,
      y: 364,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5786478b-f99b-4f4e-99ce-c731ac9cd811'
    },
    {
      id: 'ab70cded-7f08-4580-83a1-e223d80b0e58',
      type: 'Container',
      name: 'textContainer',
      className: '',
      x: 0,
      y: 600,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5786478b-f99b-4f4e-99ce-c731ac9cd811'
    },
    {
      id: '25b525d1-d02d-4605-a691-757ea1155dee',
      type: 'Container',
      name: '',
      className: 'frameSlot',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '03d602f0-9a69-449a-b822-63c64b360008'
    },
    {
      id: '5e93c51e-7278-4ed1-82fa-19bca7ea683d',
      type: 'Container',
      name: '',
      className: 'frameSlot',
      x: -220,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '03d602f0-9a69-449a-b822-63c64b360008'
    },
    {
      id: '7186807b-d613-41d1-bbb5-b7d039a2ecb2',
      type: 'Container',
      name: '',
      className: 'frameSlot',
      x: 220,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '03d602f0-9a69-449a-b822-63c64b360008'
    },
    {
      id: 'ddf198dc-c4bf-42ea-8acf-183d2f4841c2',
      type: 'Container',
      name: '',
      className: 'chestSlot',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '051c83b9-48ca-48bc-a7e8-b938b397941b'
    },
    {
      id: '1a46d898-f709-4969-8efc-cdc95da35d4a',
      type: 'Container',
      name: '',
      className: 'chestSlot',
      x: -220,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '051c83b9-48ca-48bc-a7e8-b938b397941b'
    },
    {
      id: '5255f1f9-77c1-435c-b167-3a116a18cfad',
      type: 'Container',
      name: '',
      className: 'chestSlot',
      x: 220,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '051c83b9-48ca-48bc-a7e8-b938b397941b'
    },
    {
      id: '32925080-0dc1-4e78-8af3-65525faa4fa2',
      type: 'Text',
      name: 'loseText',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'You didn\'t reach the Top 3, maybe next time!',
      localize: true,
      maxWidth: 600,
      maxHeight: 294,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 60,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 600,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'ab70cded-7f08-4580-83a1-e223d80b0e58'
    },
    {
      id: 'ffc4d3cc-8a94-49d7-8b63-294f0505daac',
      type: 'Container',
      name: 'winTextContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'ab70cded-7f08-4580-83a1-e223d80b0e58'
    },
    {
      id: '59a1b827-1298-4abc-a7a8-47465416f13e',
      type: 'Sprite',
      name: '',
      className: 'chestRays',
      x: 0,
      y: -51,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.35,
        y: 0.35
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ray',
      parent: 'ddf198dc-c4bf-42ea-8acf-183d2f4841c2'
    },
    {
      id: '122ae510-e125-44aa-95fd-8a6d31a35a0c',
      type: 'Sprite',
      name: '',
      className: 'chestRays',
      x: 0,
      y: -51,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.35,
        y: 0.35
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ray',
      parent: '1a46d898-f709-4969-8efc-cdc95da35d4a'
    },
    {
      id: '4030b569-4c69-4a55-83bd-a1f3866d5701',
      type: 'Sprite',
      name: '',
      className: 'chestRays',
      x: 0,
      y: -51,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.35,
        y: 0.35
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ray',
      parent: '5255f1f9-77c1-435c-b167-3a116a18cfad'
    },
    {
      id: '5bcbfbd3-3516-4a98-83df-f427e4e80f08',
      type: 'Text',
      name: 'winText',
      className: '',
      x: 0,
      y: -40,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'You reached the',
      localize: false,
      maxWidth: 700,
      maxHeight: 294,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 65,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 600,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'ffc4d3cc-8a94-49d7-8b63-294f0505daac'
    },
    {
      id: '3bb419be-b82e-4b72-bc24-4f4943e31521',
      type: 'Text',
      name: 'winEmphesisText',
      className: '',
      x: 0,
      y: 40,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1st Place!',
      localize: false,
      maxWidth: 600,
      maxHeight: 294,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 90,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#f9d76f',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 600,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'ffc4d3cc-8a94-49d7-8b63-294f0505daac'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 1280,
  version: '2.0.0',
  handleResize: false
} as const;

export class RaceEventEndSequenceLayout {
  static raw = raw;
  root!: Container;
  gradient!: Sprite;
  fxLayer!: Container;
  rankedFrames!: Container;
  chests!: Container;
  textContainer!: Container;
  loseText!: Text;
  winTextContainer!: Container;
  winText!: Text;
  winEmphesisText!: Text;
  frameSlot!: (Container)[];
  chestSlot!: (Container)[];
  chestRays!: (Sprite)[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
